import React from 'react';
import Button from './Button';
import  useScrollToTop from './useScrollToTop';
import compactHouseOverview from '../img/elevation_img_11.avif'; // Replace with your actual image
import compactHouseGroundFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import compactHouseFirstFloor from '../img/elevation_img_11.avif'; // Replace with your actual image
import efficientLiving from '../img/elevation_img_11.avif'; // Replace with your actual image
import urbanHouseExterior from '../img/elevation_img_11.avif'; // Replace with your actual image
import './ProjectStyles.css';

const HousePlan20x40 = () => {
  useScrollToTop();
  return (
    <div className='project-container'> {/* Using the general project container style */}
      <h2>Efficient 20x40 House Plan (800 sq ft): Smart Living Design</h2>
      <img className='project-image' src={compactHouseOverview} alt="20x40 House Overview" loading="lazy" />
      <div className='project-details'>
        <p>Explore a thoughtfully designed two-story house plan perfectly suited for a 20x40 sq ft plot (800 sq ft). This design maximizes the available space to offer comfortable and functional living across two floors, ideal for urban environments like Patna, Bihar.</p>

        <h3>Design Philosophy: Optimal Space Utilization</h3>
        <p>The primary focus of this plan is to make the most of the 800 sq ft plot. Vertical construction allows for distinct zones for living and sleeping. The layout emphasizes efficient flow and incorporates smart design solutions to create a sense of spaciousness within a compact footprint. Natural light and ventilation are key considerations for a comfortable home.</p>

        <h3>Inspiration for Efficient Urban Homes</h3>
        <div className='inspiration-gallery'>
          {/* Replace with images inspiring efficient use of space in urban homes */}
          <img src='../img/smart_kitchen_design.jpg' alt='Efficient Home Inspiration 1' className='project-image' />
          <img src='../img/vertical_storage_solution.jpg' alt='Efficient Home Inspiration 2' className='project-image' />
          <img src='../img/compact_dining_area.jpg' alt='Efficient Home Inspiration 3' className='project-image' />
          {/* Add more inspiration images as needed */}
        </div>
      </div>

      <div className='project-details'>
        <h3>Detailed Floor Plans: Maximizing Every Square Foot</h3>
        <div className='floor-plan-section'>
          <h4>Ground Floor Plan (Approx. 400 sq ft)</h4>
          <img className='project-image' src={compactHouseGroundFloor} alt="Ground Floor Plan" loading="lazy" />
          <p>The ground floor typically accommodates the main living areas. This might include a combined living and dining space, a compact kitchen, a common bathroom, and the staircase to the first floor. The layout aims for an open feel to enhance the sense of space.</p>
          <ul>
            <li><strong>Combined Living and Dining Area</strong></li>
            <li><strong>Efficiently Designed Kitchen</strong></li>
            <li><strong>Common Bathroom</strong></li>
            <li><strong>Staircase to the First Floor</strong></li>
            <li>Small Entryway</li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='floor-plan-section'>
          <h4>First Floor Plan (Approx. 400 sq ft)</h4>
          <img className='project-image' src={compactHouseFirstFloor} alt="First Floor Plan" loading="lazy" />
          <p>The first floor usually houses the private living spaces, such as bedrooms. Depending on the design, it could include a master bedroom and one additional bedroom, or potentially two smaller bedrooms, along with a bathroom.</p>
          <ul>
            <li><strong>Master Bedroom</strong></li>
            <li><strong>One Additional Bedroom (or option for two smaller)</strong></li>
            <li>Bathroom (attached or common)</li>
            <li>Small Landing Area</li>
          </ul>
          {/* Add specific room dimensions and features here */}
        </div>

        <div className='built-area-breakdown'>
          <h4>Built Area Breakdown (Approximate)</h4>
          <ul>
            <li><strong>Ground Floor:</strong> ~400 sq ft</li>
            <li><strong>First Floor:</strong> ~400 sq ft</li>
            <li><strong>Total Built Area:</strong> ~800 sq ft</li>
            <p>*Note: These are approximate figures and can vary based on the specific architectural design.</p>
          </ul>
        </div>
      </div>

      <div className='project-details'>
        <h3>Comfortable Interiors: Smart Design for Small Spaces</h3>
        <div className='interior-feature'>
          <h4>Optimized Natural Light</h4>
          <img className='project-image' src={efficientLiving} alt="Efficient Living Space" loading="lazy" />
          <p>Strategic placement of windows and the use of light interior colors can maximize the feeling of space and brightness within a smaller home.</p>
        </div>

        <div className='interior-feature'>
          <h4>Multi-Functional Spaces</h4>
          <p>Designing areas that can serve multiple purposes (e.g., a living room that can also be used for work) is crucial in maximizing the utility of a compact home.</p>
        </div>

        <div className='interior-feature'>
          <h4>Vertical Storage Solutions</h4>
          <p>Utilizing wall space for storage helps to keep the floor area clear and enhances the sense of spaciousness.</p>
        </div>

        {/* Add more interior design considerations for small homes */}
      </div>

      <div className='project-details'>
        <h3>Practical Exterior: Functional and Appealing</h3>
        <img className='project-image' src={urbanHouseExterior} alt="House Exterior" loading="lazy" />

        <div className='exterior-feature'>
          <h4>Efficient Use of Plot</h4>
          <p>The exterior design will be tailored to fit the 20x40 plot efficiently, potentially with a focus on verticality to maximize living space without a large footprint.</p>
        </div>

        <div className='exterior-feature'>
          <h4>Durable and Suitable Materials</h4>
          <p>Selecting durable and low-maintenance exterior materials is important for longevity in an urban setting.</p>
        </div>

        {/* Add more exterior design features */}
      </div>

      <div className='project-details'>
        <h3>Quality Considerations for Your 800 sq ft Home</h3>
        <div className='materials-list'>
          <h4>Material Considerations</h4>
          <ul>
            <li><strong>Structure:</strong> Reinforced Concrete</li>
            <li><strong>Exterior Walls:</strong> Brick masonry with appropriate finish</li>
            <li><strong>Roofing:</strong> Durable and weather-resistant roofing solution</li>
            <li><strong>Windows and Doors:</strong> Functional and secure options</li>
            <li><strong>Flooring:</strong> Easy-to-maintain and durable materials like tiles</li>
          </ul>
        </div>

        {/* Optional: Vaastu considerations for a smaller plot */}
        {/* <h4>Vaastu Shastra Considerations (Optional)</h4>
        <p>Even within the constraints of a smaller plot, Vaastu principles regarding the placement of the main entrance, kitchen, and bedrooms can be considered to promote positive energy flow.</p> */}
      </div>

      {/* Optional: Location and Context in Patna */}
      {/* <div className='project-details'>
        <h3>Ideal for Urban Living in Patna</h3>
        {locationMap && <img className='project-image' src={locationMap} alt="Location Map" />}
        <p>This 20x40 house plan is well-suited for the typical plot sizes found in many residential areas of Patna, offering a practical and comfortable living solution on a smaller footprint.</p>
        <div className='location-details'>
          <h4>Local Considerations</h4>
          <ul>
            <li>Designed for narrow urban plots.</li>
            <li>Focus on maximizing vertical living space.</li>
            <li>Adherence to local building regulations is essential.</li>
          </ul>
        </div>
      </div> */}

      <div className='project-details '>
        <h3>Ready to Build Your Smart Urban Home?</h3>
        <p>This efficient 20x40 two-story house plan provides a great starting point for creating a comfortable home on a smaller plot in Patna. Consult with experienced architects and builders to customize this plan to your specific needs and local building codes.</p>
        {/* Add your contact information or links to architectural services */}
        <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Discuss Your Custom Design</Button>
                </a>
      </div>
    </div>
  );
};

export default HousePlan20x40;